module.exports = __webpack_public_path__ + "static/media/link-share.cfd68019.svg";